export type ForbiddenTopic = "health" | "identity" | "payment" | "special";

// Patterns run on the label lower-cased with diacritics stripped. Bare "pas", "karta", "lek" and
// "cislo" are left out on purpose: a martial-arts belt, a membership card, a lesson and a team
// number are ordinary activity questions. A blocklist guards against carelessness, not intent.
const forbiddenPatterns: Record<ForbiddenTopic, RegExp[]> = {
  health: [
    /\bzdravot/,
    /\bzdravi\b/,
    /\balergi/,
    /\bdiagnoz/,
    /\bnemoc/,
    /\bonemocn/,
    /\blecb/,
    /\bmedikac/,
    /\bhandicap/,
    /\bpostizen/,
    /\btehot(en|n)/,
  ],
  identity: [
    /rodne cislo/,
    /\bcislo (op|obcansk\w*|pasu|dokladu|prukazu)/,
    /obcansk\w* prukaz/,
    /ridicsk\w* prukaz/,
    /cestovni pas/,
    /\bpas cislo/,
    /doklad totoznosti/,
    /\bop\b/,
  ],
  payment: [
    /\bplatebni/,
    /cislo karty/,
    /kreditni karta/,
    /\bcvv\b/,
    /\bcvc\b/,
    /\biban\b/,
    /cislo uctu/,
    /\bbankovni/,
  ],
  special: [/\bnaboz/, /\bsexualn/, /\betnick/, /\brasov/, /\bpoliticky/, /\bpoliticke? (nazor|presvedc)/],
};

const topicsInCheckOrder = Object.keys(forbiddenPatterns) as ForbiddenTopic[];

export function forbiddenTopicIn(label: string): ForbiddenTopic | null {
  const normalised = label
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return (
    topicsInCheckOrder.find((topic) => forbiddenPatterns[topic].some((pattern) => pattern.test(normalised))) ??
    null
  );
}
